import { LegalDocument } from '@/components/legal/LegalDocument'
import { PublicLegalLayout } from '@/components/layout/PublicLegalLayout'
import { termsOfService } from '@/lib/legal'

export function TermsOfServicePage() {
  return (
    <PublicLegalLayout>
      <LegalDocument
        title={termsOfService.title}
        intro={termsOfService.intro}
        sections={termsOfService.sections}
        alternateLink={{ href: '/privacy', label: 'Privacy Policy' }}
      />
    </PublicLegalLayout>
  )
}
